<template>
  <div>
    <div style="width:30%;float:left;text-align:right">
      <div>{{leftText}}</div>
    </div>
    <div style="width:70%;float:left;padding-left:10px">
      <div>{{rightText}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leftText: String,
    rightText: String,
  },
};
</script>
